import {useState} from "react";
import {css} from "@panda/css";

import {PlayIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {scheduleTrackingTask} from "../../../../tracking/utils/schedule_tracking_task";
import {IPricesHubShort, PRICES_HUB_SHORTS_CHANNEL_NAME} from "../../constants/prices_hub_shorts";
import {trackPricesHubButtonClick} from "../../tracking/track_prices_hub_button_click";
import {getShortFallbackThumbnailUrl, getShortThumbnailUrl, getShortUrl} from "../../utils/get_short_links";

interface IProps {
    short: IPricesHubShort;
}

export const PricesHubShortsTile = (props: IProps) => {
    const {short} = props;
    const [thumbnailSrc, setThumbnailSrc] = useState(() => getShortThumbnailUrl(short.videoId));

    return (
        <a
            className={tileStyle}
            href={getShortUrl(short.videoId)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${short.title} – obejrzyj na YouTube`}
            onClick={() =>
                scheduleTrackingTask(() =>
                    trackPricesHubButtonClick({buttonName: "rp_apartment_prices_short", value: short.title, buttonLink: getShortUrl(short.videoId)})
                )
            }
        >
            <span className={thumbnailStyle}>
                <img
                    className={thumbnailImageStyle}
                    src={thumbnailSrc}
                    alt=""
                    loading="lazy"
                    onError={() => setThumbnailSrc(getShortFallbackThumbnailUrl(short.videoId))}
                />
                <span className={playStyle}>
                    <PlayIcon size="1.8" fill="var(--colors-white)" />
                </span>
            </span>

            <span className={metaStyle}>
                <Text as="span" variant="body_copy_2" className={titleStyle}>
                    {short.title}
                </Text>
                <Text as="span" variant="info_txt_2" className={channelStyle}>
                    {PRICES_HUB_SHORTS_CHANNEL_NAME} · YouTube
                </Text>
            </span>
        </a>
    );
};

const tileStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    width: "100%",
    color: "var(--colors-secondary)",
    borderRadius: "1.2rem",
    textDecoration: "none",

    _hover: {
        color: "var(--colors-secondary)",
        textDecoration: "none",

        "& img": {
            transform: "scale(1.04)"
        }
    },

    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
});

const thumbnailStyle = css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "22.4rem",
    overflow: "hidden",
    backgroundColor: "var(--colors-gray-200)",
    borderRadius: "1.2rem",

    md: {
        height: "27.8rem"
    }
});

const thumbnailImageStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    maxWidth: "none",
    objectFit: "cover",
    transition: "transform 240ms ease"
});

const playStyle = css({
    position: "relative",
    display: "flex",
    width: "4.4rem",
    height: "4.4rem",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "var(--colors-danger)",
    borderRadius: "50%",
    boxShadow: "0 8px 24px -6px rgba(0, 0, 0, 0.5)"
});

const metaStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const titleStyle = css({
    color: "var(--colors-secondary)",
    lineClamp: 2
});

const channelStyle = css({
    color: "var(--colors-gray-700)"
});
import {useState} from "react";
import {css} from "@panda/css";

import {PlayIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {scheduleTrackingTask} from "../../../../tracking/utils/schedule_tracking_task";
import {IPricesHubShort, PRICES_HUB_SHORTS_CHANNEL_NAME} from "../../constants/prices_hub_shorts";
import {trackPricesHubButtonClick} from "../../tracking/track_prices_hub_button_click";
import {getShortFallbackThumbnailUrl, getShortThumbnailUrl, getShortUrl} from "../../utils/get_short_links";

interface IProps {
    short: IPricesHubShort;
}

export const PricesHubShortsTile = (props: IProps) => {
    const {short} = props;
    const [thumbnailSrc, setThumbnailSrc] = useState(() => getShortThumbnailUrl(short.videoId));

    return (
        <a
            className={tileStyle}
            href={getShortUrl(short.videoId)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${short.title} – obejrzyj na YouTube`}
            onClick={() =>
                scheduleTrackingTask(() =>
                    trackPricesHubButtonClick({buttonName: "rp_apartment_prices_short", value: short.title, buttonLink: getShortUrl(short.videoId)})
                )
            }
        >
            <span className={thumbnailStyle}>
                <img
                    className={thumbnailImageStyle}
                    src={thumbnailSrc}
                    alt=""
                    loading="lazy"
                    onError={() => setThumbnailSrc(getShortFallbackThumbnailUrl(short.videoId))}
                />
                <span className={playStyle}>
                    <PlayIcon size="1.8" fill="var(--colors-white)" />
                </span>
            </span>

            <span className={metaStyle}>
                <Text as="span" variant="body_copy_2" className={titleStyle}>
                    {short.title}
                </Text>
                <Text as="span" variant="info_txt_2" className={channelStyle}>
                    {PRICES_HUB_SHORTS_CHANNEL_NAME} · YouTube
                </Text>
            </span>
        </a>
    );
};

const tileStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    width: "100%",
    color: "var(--colors-secondary)",
    borderRadius: "1.2rem",
    textDecoration: "none",

    _hover: {
        color: "var(--colors-secondary)",
        textDecoration: "none",

        "& img": {
            transform: "scale(1.04)"
        }
    },

    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
});

const thumbnailStyle = css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "22.4rem",
    overflow: "hidden",
    backgroundColor: "var(--colors-gray-200)",
    borderRadius: "1.2rem",

    md: {
        height: "27.8rem"
    }
});

const thumbnailImageStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    maxWidth: "none",
    objectFit: "cover",
    transition: "transform 240ms ease"
});

const playStyle = css({
    position: "relative",
    display: "flex",
    width: "4.4rem",
    height: "4.4rem",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "var(--colors-danger)",
    borderRadius: "50%",
    boxShadow: "0 8px 24px -6px rgba(0, 0, 0, 0.5)"
});

const metaStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const titleStyle = css({
    color: "var(--colors-secondary)",
    lineClamp: 2
});

const channelStyle = css({
    color: "var(--colors-gray-700)"
});
